import { render, staticRenderFns } from "./TcVideo.vue?vue&type=template&id=4135c3c6"
import script from "./TcVideo.vue?vue&type=script&lang=js"
export * from "./TcVideo.vue?vue&type=script&lang=js"
import style0 from "./TcVideo.vue?vue&type=style&index=0&id=4135c3c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports